import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogResult, RequestConfig } from '../../app-json-config/app-json-config.component';
import { HTTPService } from 'src/app/services/http.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SnackbarService } from 'src/app/services/snackbar.service';



@Component({
  selector: 'app-request-config',    
  templateUrl: './request-config.component.html',
  styleUrl: './request-config.component.scss',
  standalone: false
})
export class RequestConfigComponent {
  constructor( private snackBar: SnackbarService, private spinner: NgxSpinnerService,private http:HTTPService,
    public dialogRef: MatDialogRef<RequestConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { formula: string; variables: any[]; requestConfig: RequestConfig,  globalParams?: any[] }
  ) {}

  json:any;
  requestRunning = false;
  statusMessage: string;
 
 testFormula(type: string) {
    const formulaField = type === 'B' ? 'formula' : 'headerFormula';
    const formula = this.data[formulaField] || '';
    const variables = this.data.variables.map(v => ({
      name: v.name,
      value: prompt(`Digite o valor para ${v.name}:`, '')
    }));

    let resolvedFormula = formula;
    variables.forEach(v => {
      resolvedFormula = resolvedFormula.replace(`\${${v.name}}`, v.value || '');
    });

    console.log(`Testando ${type === 'B' ? 'Body' : 'Header'} Formula:`, resolvedFormula);
    alert(`Resultado do teste:\n${resolvedFormula}\n(Nota: Execução real será na outra tela)`);
  }

  save(): void {
    const result: DialogResult = {
      formula: this.data.formula,
      requestConfig: this.data.requestConfig
    };
    this.dialogRef.close(result);
  }

  testRequest(): void {
    const req = this.data.requestConfig;
    const ob = {
      expressao: `getRequestData("${req.serviceName}", "${req.urlType || 'null'}", "${req.params}", "${req.method}", "${req.bodyFormula || 'null'}", "${req.headerFormula || 'null'}", "${req.codeMktp}")`,
      novo: true,
      codecompany: this.getGlobalParam('codecompany') || '', // Injetar do contexto global
      codemktp: req.codeMktp || '0',
      codecontract: '0',
      values: []
    };

    // Adicionar header se existir
    if (req.headerFormula) {
      ob.values.push({ key: '@HEADER', value: req.headerFormula });
    }

    // Injetar todos os parâmetros globais da tela anterior
    const globalParams = this.data.globalParams || [];
    globalParams.forEach(param => {
      if (param.PARNAME && param.TYPE !== 'R' && !ob.values.some(v => v.key === `@${param.PARNAME}`)) {
        ob.values.push({ key: `@${param.PARNAME}`, value: prompt(`Digite o valor para ${param.PARNAME}:`, '') });
      }
    });

    console.log('Requisição de teste:', ob);

    let spinnerMsg = "Executando Requisição de teste";

    this.statusMessage = "Executando Requisição de teste ...";
    
    this.spinner.show(spinnerMsg);
    this.requestRunning = true;

    this.http.post(ob, 'FormulaServices/test', true, true, false).subscribe(
      data => {
        console.log('Resposta do teste:', data);
       // alert(`Teste bem-sucedido!\nResposta: ${JSON.stringify(data)}`);
        this.statusMessage = "Teste bem-sucedido!";

        const parsedData = typeof data === 'string' ? JSON.parse(data) : data;

        const resultadoJsonString = parsedData.resultado;
       

        this.json = JSON.parse(resultadoJsonString);
      },
      error => {
        console.error('Erro no teste:', error);
        alert(`Erro no teste:\n${error.message}`);
          this.spinner.hide(spinnerMsg);
          this.requestRunning = false;
          this.statusMessage = "";          
      },
      () => {
        console.log('Teste concluído');
      }
    );
  }

  getFormattedJSON(): string {
    return JSON.stringify(this.json, null, 2);
  }


  // Método auxiliar para obter parâmetros globais
  private getGlobalParam(paramName: string): string | undefined {
    const param = (this.data.globalParams || []).find(p => p.PARNAME.toLowerCase() === paramName.toLowerCase());
    return param ? param.PARNAME : undefined; 
  }

  copyJson() {
    const jsonText = this.getFormattedJSON();
    navigator.clipboard.writeText(jsonText).then(() => {
      this.statusMessage = 'JSON copiado para a área de transferência!';
    }).catch(err => {
      console.error('Erro ao copiar JSON:', err);
      this.statusMessage = 'Erro ao copiar o JSON';
    });
  }

}
